"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonSimpleCrudForm = exports.OktonSimpleCrudList = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
const DataGrid_1 = require("../DataGrid");
const Feedback_1 = require("../Feedback");
const Form_1 = require("../Form");
const Page_1 = require("../Page");
const Filters_1 = require("../Filters");
const OktonSimpleCrudList = ({ title, description, newLabel, icon, emptyMessage, items, loading, error, onRetry, onNew, onEdit, onDelete, deleteConfirmation, detailColumnTitle, searchPlaceholder = 'Buscar por código ou nome...', }) => {
    const toast = (0, react_1.useToast)();
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    const [deletingId, setDeletingId] = react_2.default.useState(null);
    const [pendingDeleteId, setPendingDeleteId] = react_2.default.useState(null);
    const [search, setSearch] = react_2.default.useState('');
    const columns = react_2.default.useMemo(() => {
        const base = [
            {
                chave: 'id',
                titulo: 'Código',
                valor: item => Number(item.id),
                tipo: 'numero',
                largura: '90px',
            },
            { chave: 'name', titulo: 'Nome', valor: item => item.name },
        ];
        if (detailColumnTitle) {
            base.push({
                chave: 'detail',
                titulo: detailColumnTitle,
                valor: item => item.detail,
            });
        }
        return base;
    }, [detailColumnTitle]);
    const { ordenacao, alternarOrdenacao, itens: visible, filtrados: filtered, pagina, setPagina, tamanhoPagina, setTamanhoPagina, } = (0, DataGrid_1.useGrid)(items, columns, search);
    const sortableHeader = (column) => {
        const active = (ordenacao === null || ordenacao === void 0 ? void 0 : ordenacao.chave) === column.chave;
        const sortIcon = !active
            ? react_2.default.createElement(lu_1.LuChevronsUpDown, { size: 13 })
            : (ordenacao === null || ordenacao === void 0 ? void 0 : ordenacao.desc)
                ? react_2.default.createElement(lu_1.LuArrowDown, { size: 13 })
                : react_2.default.createElement(lu_1.LuArrowUp, { size: 13 });
        return (react_2.default.createElement(react_1.Button, { variant: "ghost", size: "xs", px: "0", h: "auto", fontWeight: "medium", rightIcon: sortIcon, onClick: () => alternarOrdenacao(column.chave) }, column.titulo));
    };
    const gridColumns = [
        {
            key: 'id',
            header: sortableHeader(columns[0]),
            width: '90px',
            render: item => item.id,
        },
        {
            key: 'name',
            header: sortableHeader(columns[1]),
            render: item => react_2.default.createElement(react_1.Box, { fontWeight: "bold" }, item.name),
        },
        ...(detailColumnTitle
            ? [
                {
                    key: 'detail',
                    header: sortableHeader(columns[2]),
                    render: (item) => item.detail || '—',
                },
            ]
            : []),
        {
            key: 'actions',
            header: null,
            align: 'right',
            render: item => (react_2.default.createElement(react_1.Flex, { justify: "flex-end", gap: "1" },
                react_2.default.createElement(react_1.Button, { size: "sm", variant: "ghost", colorScheme: "blue", leftIcon: react_2.default.createElement(lu_1.LuPencil, { size: 14 }), onClick: () => onEdit(item.id) }, "Editar"),
                react_2.default.createElement(react_1.IconButton, { "aria-label": "Excluir", size: "sm", variant: "ghost", colorScheme: "red", icon: react_2.default.createElement(lu_1.LuTrash2, { size: 16 }), isLoading: deletingId === item.id, onClick: () => setPendingDeleteId(item.id) }))),
        },
    ];
    const confirmDelete = async () => {
        if (!pendingDeleteId)
            return;
        setDeletingId(pendingDeleteId);
        try {
            await onDelete(pendingDeleteId);
            setPendingDeleteId(null);
        }
        catch (err) {
            toast({
                title: err instanceof Error ? err.message : 'Erro ao excluir.',
                status: 'error',
                position: 'bottom-right',
                isClosable: true,
            });
        }
        finally {
            setDeletingId(null);
        }
    };
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(Page_1.OktonPageHeader, { eyebrow: "CADASTROS", title: title, subtitle: description, actions: react_2.default.createElement(react_1.Flex, { ml: "auto", my: "3", align: "center", gridGap: 2, flexWrap: "wrap" },
                react_2.default.createElement(Filters_1.OktonSearchFilter, { value: search, onChange: setSearch, placeholder: searchPlaceholder }),
                react_2.default.createElement(react_1.Flex, { borderWidth: "1px", p: "2", rounded: "2xl", bg: bg, align: "center", gridGap: 2 },
                    react_2.default.createElement(react_1.Button, { leftIcon: react_2.default.createElement(lu_1.LuPlus, { size: 18 }), colorScheme: "blue", onClick: onNew, minW: "150px" }, newLabel))) }),
        loading ? (react_2.default.createElement(react_1.Flex, { mx: "6", mt: "1" },
            react_2.default.createElement(Feedback_1.OktonLoadingCard, { h: "200px" }))) : error ? (react_2.default.createElement(react_1.Flex, { mx: "6", mt: "1" },
            react_2.default.createElement(Feedback_1.OktonErrorCard, { h: "200px", onRetry: onRetry }))) : (react_2.default.createElement(react_1.Box, { bg: bg, mx: "6", mt: "1", rounded: "2xl" }, filtered.length === 0 ? (react_2.default.createElement(Page_1.OktonEmptyState, { icon: icon, title: search ? 'Nada encontrado para a busca' : emptyMessage })) : (react_2.default.createElement(DataGrid_1.OktonDataGrid, { rows: visible, columns: gridColumns, getRowId: item => item.id, page: pagina + 1, pageSize: tamanhoPagina, total: filtered.length, pageSizeOptions: DataGrid_1.TAMANHOS_PAGINA, onPageChange: nextPage => setPagina(nextPage - 1), onPageSizeChange: setTamanhoPagina })))),
        react_2.default.createElement(Feedback_1.OktonConfirmDialog, { isOpen: Boolean(pendingDeleteId), onClose: () => {
                if (!deletingId)
                    setPendingDeleteId(null);
            }, onConfirm: confirmDelete, title: "Confirmar exclus\u00E3o", description: deleteConfirmation, confirmLabel: "Excluir", intent: "danger", isLoading: Boolean(deletingId) })));
};
exports.OktonSimpleCrudList = OktonSimpleCrudList;
const OktonSimpleCrudForm = ({ title, description, nameLabel, name, onNameChange, maxName, error, saving = false, onSave, onCancel, children, footer, }) => {
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(Page_1.OktonPageHeader, { eyebrow: "CADASTROS", title: title, subtitle: description, onBack: onCancel }),
        react_2.default.createElement(react_1.Box, { bg: bg, mx: "6", mt: "4", borderWidth: "1px", rounded: "2xl", p: "6" },
            react_2.default.createElement(react_1.Stack, { spacing: "4", maxW: "720px" },
                error ? (react_2.default.createElement(react_1.Box, { bg: "red.50", color: "red.600", fontSize: "sm", borderRadius: "lg", px: "4", py: "2" }, error)) : null,
                react_2.default.createElement(Form_1.OktonInput, { name: "okton-simple-crud-name", label: nameLabel + ' *', size: "lg", rounded: "2xl", fontWeight: "light", maxLength: maxName, value: name, onChange: event => onNameChange(event.target.value) }),
                children,
                footer,
                react_2.default.createElement(react_1.Flex, { gridGap: "3", pt: "2" },
                    react_2.default.createElement(react_1.Button, { variant: "ghost", onClick: onCancel }, "Cancelar"),
                    react_2.default.createElement(react_1.Button, { colorScheme: "blue", leftIcon: saving
                            ? react_2.default.createElement(react_1.Spinner, { size: "sm" })
                            : react_2.default.createElement(lu_1.LuCheck, { size: 16 }), isDisabled: saving, onClick: onSave }, "Salvar"))))));
};
exports.OktonSimpleCrudForm = OktonSimpleCrudForm;
//# sourceMappingURL=index.js.map